import { DateTime } from 'luxon'

/**
 * Heures et jours du Pilotage, toujours ceux de Paris : libellés des appels de prod et des jours de
 * la semaine. Logique pure, testée par `pilotage-call-track.test.mjs`.
 */

export const PILOTAGE_ZONE = 'Europe/Paris'

/** Jours abrégés, du lundi au dimanche. */
export const PILOTAGE_WEEKDAYS = ['lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.', 'dim.'] as const

const hourLabel = (hour: number, minute: number): string =>
  minute === 0 ? `${hour} h` : `${hour} h ${String(minute).padStart(2, '0')}`

/** « 9 h », « 14 h 55 » : heure de Paris d'un instant. */
export const pilotageHourLabel = (iso: string): string => {
  const at = DateTime.fromISO(iso, { zone: PILOTAGE_ZONE })
  return hourLabel(at.hour, at.minute)
}

/** « 9 h », « 14 h 55 » : une heure `HH:mm` déjà en heure de Paris. */
export const pilotageClockLabel = (heure: string): string => {
  const [hour = 0, minute = 0] = heure.split(':').map(Number)
  return hourLabel(hour, minute)
}

/** « mar. 27/10 » : jour de Paris d'un instant ou d'une date ISO. */
export const pilotageDayLabel = (iso: string): string => {
  const at = DateTime.fromISO(iso, { zone: PILOTAGE_ZONE })
  return `${PILOTAGE_WEEKDAYS[at.weekday - 1]} ${at.toFormat('dd/LL')}`
}

/** « mar. 27/10 à 14 h 55 » : jour et heure de Paris d'un instant. */
export const pilotageInstantLabel = (iso: string): string =>
  `${pilotageDayLabel(iso)} à ${pilotageHourLabel(iso)}`
